module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/pc/hospital_detail/bnr_468_60-5622c8c045f2254c3e3d6ab7b96e2a5d.png";